/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import * as BE from '@sick-davinci/basic-elements';

import { run } from './Navigation';
import { Events, ViewportChangedEvent } from '@sick-davinci/glow';

const PRESERVE = [BE]; // prevent the build pipeline from removal by optimizing ..

const demo = run(document.getElementById('viewer'));

demo.stage.addEventListener(Events.VIEWPORTCHANGED, ({detail}: CustomEvent<ViewportChangedEvent>) => {

  const viewport = detail.camera;

  document.querySelectorAll('.viewportActivated').forEach((el: HTMLElement) => {
    el.style.display = 'none';
  });

  (document.querySelector(`.viewportActivated.${viewport}`) as HTMLElement).style.display = 'block';

});

window.addEventListener('WebComponentsReady', () => {

  document.getElementById('primary').style.display = 'block';
  document.getElementById('secondary').style.display = 'block';

  linkGuiToNavigators('#primary', 'primary');
  linkGuiToNavigators('#secondary', 'secondary');

});

function linkGuiToNavigators(selector: string, viewport: string) {

  document.querySelector(`${selector} .navigatorScheme`).addEventListener('change', ({detail}: CustomEvent) => {

    const navigator = detail;

    console.log('change', viewport, 'to', navigator);

    demo.stage.changeNavigator(navigator, viewport);

  });

}
